export enum NotificationActionEnum {
  NEW_BOOK = 'newBook',
  NEW_CHAPTER = 'newChapter',
  CONTENT_UPDATE = 'contentUpdate',
  END_BOOK = 'endBook',
  NEW_NEWS = 'newNews',
  NEW_PROMOTION = 'newPromotion',
  NEW_FOLLOWER = 'newFollower',
  NEW_LIKE = 'newLike',
  NEW_DONATION = 'newDonation',
  NEW_REPLY = 'newReply',
  NEW_COMMENT_WRITER = 'newCommentWriter',
  WRITER_REGISTER_APPROVE = 'writerRegisterApprove',
  WRITER_REGISTER_REJECT = 'writerRegisterReject',
  WRITER_EDIT_APPROVE = 'writerEditApprove',
  WRITER_EDIT_REJECT = 'writerEditReject',
  NEW_CHAPTERS = 'newChapters',
  AGE_VERIFY_REJECT = 'ageVerifyReject',
  AGE_VERIFY_APPROVE = 'ageVerifyApprove',
  NEW_CHAT_MESSAGE = 'newChatMessage',
  EBOOK_UPDATE = 'ebookUpdate',
  EBOOK_PUBLISH = 'ebookPublish',
  EBOOK_UNPUBLISH = 'ebookUnpublish',
}
